import { FC, useRef } from "react";
import { Box } from "@mui/material";
import { Modal, ModalTitle, ModalContent, ModalActions, Button } from "ui";
import { useDispatch } from "react-redux";
import { modalHide } from "app/App/actions";
import { OrderV2Location } from "../types";
import OrderV2PermissionsForm from "../forms/OrderV2PermissionsForm";

type TOrderV2PermissionsModal = {
    applicationKey: string;
    location: OrderV2Location;
    userId: number;
    onClose: Function;
};

const OrderV2PermissionsModal: FC<TOrderV2PermissionsModal> = ({
    applicationKey,
    location,
    onClose,
    userId,
}) => {
    const dispatch = useDispatch();
    const formRef = useRef<any>();

    const handleClose = () => {
        onClose();
        dispatch(modalHide("OrderV2PermissionsModal"));
    };

    const handleSaveForm = (
        event: React.FormEvent<HTMLFormElement | HTMLButtonElement>
    ) => {
        formRef.current?.onSubmit(event);
    };

    return (
        <Modal open maxWidth="md" fullWidth onClose={handleClose}>
            <ModalTitle onClose={handleClose}>{location.name}</ModalTitle>

            <ModalContent sx={{ p: 2 }}>
                <OrderV2PermissionsForm
                    applicationKey={applicationKey}
                    location={location}
                    userId={userId}
                    ref={formRef}
                />
            </ModalContent>
            <ModalActions>
                <Box display="flex" width="100%" textAlign="right">
                    <Button
                        onClick={handleClose}
                        color="inherit"
                        variant="text"
                        sx={{ mr: 1 }}
                    >
                        Cancel
                    </Button>
                    <Button sx={{ flex: 1 }} onClick={handleSaveForm}>
                        Save
                    </Button>
                </Box>
            </ModalActions>
        </Modal>
    );
};

export default OrderV2PermissionsModal;
